import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import {
  LoadingPanelComponent,
  LoadingState,
} from '../core/panels/loading-panel.component';
import { HomeCardComponent } from '../home/home-card.component';
import { SidekickSummaryComponent } from '../view/claim-summary/sidekick-summary/sidekick-summary.component';

@Component({
  selector: 'app-juris-sidekick-sso-page',
  imports: [LoadingPanelComponent, SidekickSummaryComponent, HomeCardComponent],
  template: `
    <app-home-card type="Large">
      <div class="tw-pb-8 tw-w-full tw-min-w-0">
        <app-loading-panel
          [state]="loadingState"
          loadingStyle="Box"
          [loadingHeight]="450"
          [error]="error"
        >
          <ng-template #loaded>
            <app-sidekick-summary />
          </ng-template>
        </app-loading-panel>
      </div>
    </app-home-card>
  `,
})
export class JurisSidekickSsoPageComponent
  extends BaseComponent
  implements OnInit
{
  loadingState: LoadingState = 'Loading';
  error: string = null;

  private readonly supportedLobs = ['WC', 'GL', 'PR', 'AU'];

  async ngOnInit(): Promise<void> {
    const recordSource =
      this.activatedRoute.parent?.snapshot.params['recordSource'];
    const recordId = this.activatedRoute.parent?.snapshot.params['recordId'];

    if (!recordSource || !recordId) {
      this.error = 'Invalid claim parameters.';
      return;
    }

    try {
      const claimHeader = await this.api.claimHeader.get({
        recordSource,
        recordId,
      });
      this.view.setCurrentClaim(claimHeader);

      if (!this.supportedLobs.includes(claimHeader.lineOfBusiness)) {
        this.error = 'An Omni AI Summary cannot be produced for this claim.';
        return;
      }

      this.loadingState = 'Loaded';
    } catch {
      this.error = 'An error occurred while loading the claim.';
    }
  }
}
